var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navigation'),_vm._m(0),_c('Posts',{attrs:{"Category":"design-tips","ShowTitle":"false"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section bg-primary-3"},[_c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("Design Tips")]),_c('div',{staticClass:"text-large"},[_vm._v("Show off your creative side with these great design tips.")])])])
}]

export { render, staticRenderFns }